import { render, staticRenderFns } from "./gpb-usd.vue?vue&type=template&id=4d16f42c&scoped=true&"
import script from "./gpb-usd.vue?vue&type=script&lang=js&"
export * from "./gpb-usd.vue?vue&type=script&lang=js&"
import style0 from "./gpb-usd.vue?vue&type=style&index=0&id=4d16f42c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d16f42c",
  null
  
)

export default component.exports